import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../layout/Header'
import Footer from '../layout/Footer'
import { useTranslation } from 'react-i18next';
import '../i18n'; // important to import
const BusinessUserDetails = () => {
         const { t } = useTranslation('BusinessOwnerDetails');
    
    return (
        <>
            <Header />
            <section>
                <div className="container-fluid">
                    <div className="sign-up-main">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-12 col-md-6 position-relative bg-primary d-flex justify-content-center align-items-center sign-up-col vh-md-100">
                                <img
                                    src="./login/individual-user-vector-1.png"
                                    className="sing-vector-1"
                                    alt=""
                                />
                                <img
                                    src="./login/woman-home.webp"
                                    className="project-team"
                                    alt=""
                                />
                                <img
                                    src="./login/individual-user-vector-2.png"
                                    className="sing-vector-2"
                                    alt=""
                                />
                            </div>
                            <div className="col-12 col-md-6 position-relative d-flex justify-content-center align-items-start align-items-md-center sign-up-col sign-up-col-sm vh-md-100">
                                <div className="col-12 col-md-12 col-lg-10 col-xl-9">
                                    <form className="row g-3 form-main">
                                        <div className="col-md-12">
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label htmlFor="inputState" className="form-label">
                                                    {t("whatsyourrole")}
                                                </label>
                                                <select id="inputState" className="form-select">
                                                    <option>{t("choose")} ...</option>
                                                    <option selected="">{t("manager")} </option>
                                                </select>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label htmlFor="inputState" className="form-label">
                                                   {t("whattopicwouldyouliketoreplace")}
                                                </label>
                                                <select id="inputState" className="form-select">
                                                    <option>{t("choose")}...</option>
                                                    <option selected="">{t("itandsecurity")} </option>
                                                </select>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label className="form-label"> {t("name")} </label>
                                                <input
                                                    className="form-control"
                                                    placeholder={t("nameplaceholder")}
                                                />
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 mb-5">
                                                <label className="form-label">{t("emailaddress")} </label>
                                                <input
                                                    className="form-control"
                                                    placeholder={t("emailplaceholder")}
                                                />
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xl-8 d-flex justify-content-end">
                                                <Link
                                                    to="/business-subscription"
                                                    className="btn-explore d-flex align-items-center fw-400 gap-3 rounded-2"
                                                >
                                                   {t("submit")}
                                                </Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default BusinessUserDetails